import { propClassName } from '@/styles/ContentList';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';
import { ListItemComponent } from './List.Item';

interface OlListProps extends ComponentProps<'ol'> {
  as: 'ol';
}

interface UlListProps extends ComponentProps<'ul'> {
  as: 'ul';
}

export type BaseListProps = OlListProps | UlListProps;

export type ListProps = BaseListProps & {
  variant?: ClassNameProp;
  colors?: ClassNameProp;
  size?: ClassNameProp;
};

const ListComponent: Component<ListProps> = ({ as, variant, colors, size, className, children, ...props }) => {
  const variantClassName = propClassName('variant', variant);
  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);

  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  const Component = as;

  return (
    <Component className={componentClassName} {...props}>
      {children}
    </Component>
  );
};

export const List = Object.assign(ListComponent, {
  Item: ListItemComponent,
});
